import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import BookingEditDisplay from './editForm/Booking.edit.display';

export default function (...extend: any) {
  return nestedComponentForm(
    [
      {
        key: 'display',
        components: BookingEditDisplay,
      },
    ],
    ...extend
  );
}
